import styled from "styled-components"

const OList = styled.ol`
  font-family: ${props => props.theme.fonts.serif};
  padding-left: 18px;
`

export default OList
